<template>
  <ServerPage :action="() => api.pagamentos.exibirRetirados(id)">
    <template v-slot:default="{ serverData }">
      <v-toolbar class="mx-3" flat color="transparent">
        <v-btn :to="{ name: 'locacoes_pagamentos_retirados_page' }" icon exact>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container style="max-width: 900px;">
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                Retirada cód. {{ id }}
                <v-spacer></v-spacer>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="reverter()" class="red--text">
                      <v-list-item-icon>
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="red--text">
                          Excluir
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          Total retirado
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{ serverData.total_retirado }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          Data
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{ serverData.cadastrado_em }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          Responsável
                        </v-list-item-subtitle>
                        <v-list-item-title>
                          {{ serverData.usuario.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                Locações
              </v-card-title>
              <v-divider></v-divider>
              <v-simple-table>
                <tbody>
                  <tr v-for="locacao in serverData.locacoes" :key="locacao.id">
                    <th>
                      <RouterLink
                        :to="{
                          name: 'locacoes_locacao_page',
                          params: { codigo: locacao.codigo }
                        }"
                        target="_blank"
                      >
                        {{ locacao.codigo }}
                      </RouterLink>
                    </th>
                    <td class="text-right">
                      {{ locacao.total_pago }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>Total</th>
                    <td class="text-right">
                      {{ serverData.total_retirado }}
                    </td>
                  </tr>
                </tfoot>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                Observações
              </v-card-title>
              <v-card-text>
                <v-textarea
                  v-model="serverData.observacoes"
                  placeholder="Digite para adicionar observações..."
                  @input="touched = true"
                  filled
                  auto-grow
                >
                </v-textarea>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="atualizar(serverData.observacoes)"
                  color="primary"
                  :disabled="!touched"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </ServerPage>
</template>

<script>
import ServerPage from "@/components/server/ServerPage.vue";
import api from "@/services/locacoes";

export default {
  mixins: [],

  components: {
    ServerPage
  },

  props: {
    id: [String, Number]
  },

  data() {
    return {
      api,
      touched: false
    };
  },

  methods: {
    async atualizar(observacoes) {
      await api.pagamentos.atualizarRetirados(this.id, {
        observacoes
      });
      this.touched = false;
    },

    async reverter() {
      if (!confirm("Tem certeza? A ação não poderá ser desfeita")) {
        return;
      }

      await api.pagamentos.reverterRetirada(this.id);
      this.$router.replace({ name: "locacoes_pagamentos_retirados_page" });
    }
  },

  computed: {}
};
</script>
